import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import ElectricalServicesOutlinedIcon from '@mui/icons-material/ElectricalServicesOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import * as React from 'react';
import { useHistory } from 'react-router-dom';

import { ACCOUNT_SECURITY_PATH } from '../auth/RecoveryCodesStep';
import { ContextStore } from '../store/contextStore';

/**
 * The user menu behind the avatar at the bottom of the sidebar: "My profile" (what a click on the avatar
 * always opened), "Sign-in security" (dashboard MFA: only while the bootstrap carries `mfa`, i.e. the backend's
 * feature is on) and "MCP connections" (metaplan A10, D-menu round 4: MCP connections in the user menu).
 * The drawer sits at zIndex 10000, so the menu's popover goes above it.
 */
export const MCP_CONNECTIONS_PATH = '/mcp-connections';

const UserMenu = ({ user, avatar, onNavigate }) => {
    const history = useHistory();
    const store = React.useContext(ContextStore);
    const showSecurity = !!store?.bootstrap?.mfa;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const go = (path) => {
        setAnchorEl(null);
        if (onNavigate) onNavigate();
        history.push(path);
    };
    return (
        <>
            <span
                role="button"
                tabIndex={0}
                aria-label="Open the user menu"
                aria-haspopup="menu"
                style={{ cursor: 'pointer', display: 'inline-flex' }}
                onClick={(ev) => setAnchorEl(ev.currentTarget)}
                onKeyDown={(ev) => {
                    if (ev.key === 'Enter' || ev.key === ' ') setAnchorEl(ev.currentTarget);
                }}
            >
                {avatar}
            </span>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                sx={{ zIndex: 100000 }}
            >
                <MenuItem onClick={() => go(`/user/${user?.id}`)}>
                    <ListItemIcon><PersonOutlineIcon fontSize="small" /></ListItemIcon>
                    <ListItemText>My profile</ListItemText>
                </MenuItem>
                {showSecurity && (
                    <MenuItem onClick={() => go(ACCOUNT_SECURITY_PATH)}>
                        <ListItemIcon><VerifiedUserOutlinedIcon fontSize="small" /></ListItemIcon>
                        <ListItemText>Sign-in security</ListItemText>
                    </MenuItem>
                )}
                <MenuItem onClick={() => go(MCP_CONNECTIONS_PATH)}>
                    <ListItemIcon><ElectricalServicesOutlinedIcon fontSize="small" /></ListItemIcon>
                    <ListItemText>MCP connections</ListItemText>
                </MenuItem>
            </Menu>
        </>
    );
};

export default UserMenu;
